import React from "react";
import "../css/About.css";
import RecentEvents from "../components/RecentEvents";

const About = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <div className="about-text">
          <h1>About Us</h1>
          <p>
            Welcome to Flotec! We have been in business for over 40 years, proudly serving the medical device industry.
            Based in Indiana, we specialize in manufacturing high-quality respiratory devices for a variety of sectors,
            including EMS, hospitals, and home care.
          </p>
          <p>
            Our mission is to provide innovative solutions and exceptional service to help our clients improve patient care
            and meet their unique needs. If you're interested in exploring our OEM products or how we can assist your
            business, please don't hesitate to contact us.
          </p>
        </div>
        <div className="about-image">
          <img
            src="TESTDEMO/P-Contact%20Us.png"
            alt="About us"
          />
        </div>


      </div>

      <div className="about-banner">
        <div className="banner-text">
          <h2>Discover More About Flotec</h2>
          <p>Learn about our history, values, and commitment to the medical device industry.</p>
          <a
            href="/ABOUT/B-AboutFlotec.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="banner-button"
          >
            View Company History (PDF)
          </a>
        </div>
      </div>

      <RecentEvents />

    </div>
  );
};

export default About;
